import { Column } from "../../../../../components/table-simple/table.types";
import { IGetEiacFilesCountData } from "../../../../../services/ClientsDashboardServices.dto";
import { EiacFileType } from "../../clients-dashboard-types";

export const formatEaicFilesTableData = (
  data: IGetEiacFilesCountData[] | null,
  fileType: EiacFileType = "all",
) => {
  if (!data || !data.length) {
    return null;
  }

  const columns: Column[] = [
    {
      title: "Tipo fichero",
      key: "primera",
      position: "center",
    },
  ];
  const tableData: { [key: string]: string | number }[] = [];
  if (fileType === "all") {
    tableData.push({ primera: "Pólizas" }, { primera: "Recibos" });
  } else if (fileType === "receips") {
    tableData.push({ primera: "Recibos " });
  } else if (fileType === "policies") {
    tableData.push({ primera: "Pólizas" });
  }

  data.forEach((item: IGetEiacFilesCountData) => {
    const { date, receipts, policies } = item;
    columns.push({ title: date, key: date, position: "center" });
    if (fileType === "all") {
      tableData[0][date] = policies;
      tableData[1][date] = receipts;
    } else if (fileType === "policies") {
      tableData[0][date] = policies;
    } else if (fileType === "receips") {
      tableData[0][date] = receipts;
    }
  });

  return {
    columns,
    tableData,
  };
};
